// Watch Progress Utility
// Stores and retrieves webinar watch progress in localStorage

const WATCH_PROGRESS_KEY = 'webinar_watch_progress';

export const getWatchProgress = () => {
  try {
    const progress = localStorage.getItem(WATCH_PROGRESS_KEY);
    return progress ? JSON.parse(progress) : {};
  } catch (error) {
    console.error('Error reading watch progress:', error);
    return {};
  }
};

export const saveWatchProgress = (webinarId, progressData) => {
  try {
    const allProgress = getWatchProgress();
    allProgress[webinarId] = {
      ...progressData,
      lastWatched: new Date().toISOString(),
    };
    localStorage.setItem(WATCH_PROGRESS_KEY, JSON.stringify(allProgress));
  } catch (error) {
    console.error('Error saving watch progress:', error);
  }
};

export const getWebinarProgress = (webinarId) => {
  const allProgress = getWatchProgress();
  return allProgress[webinarId] || null;
};

export const getContinueWatchingList = () => {
  const allProgress = getWatchProgress();
  
  // Filter webinars that are partially watched (between 5% and 95%)
  const continueWatching = Object.entries(allProgress)
    .filter(([_, data]) => {
      const percentage = data.percentage || 0;
      return percentage >= 5 && percentage < 95;
    })
    .map(([webinarId, data]) => ({
      webinarId,
      ...data,
    }))
    .sort((a, b) => new Date(b.lastWatched) - new Date(a.lastWatched))
    .slice(0, 4);
  
  return continueWatching;
};

export const clearWatchProgress = (webinarId) => {
  try {
    const allProgress = getWatchProgress();
    delete allProgress[webinarId];
    localStorage.setItem(WATCH_PROGRESS_KEY, JSON.stringify(allProgress));
  } catch (error) {
    console.error('Error clearing watch progress:', error);
  }
};

export const markAsComplete = (webinarId) => {
  try {
    const allProgress = getWatchProgress();
    if (allProgress[webinarId]) {
      allProgress[webinarId].percentage = 100;
      allProgress[webinarId].completed = true;
      allProgress[webinarId].lastWatched = new Date().toISOString();
      localStorage.setItem(WATCH_PROGRESS_KEY, JSON.stringify(allProgress));
    }
  } catch (error) {
    console.error('Error marking as complete:', error);
  }
};
